import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getClientsData,
  getClientsDatabyPagination,
  getClientsDatabyPaginationbySearch,
  getRegionDetail,
} from "../../../api/User/commonApi";
import {
  getCompanySize,
  GetIndustry,
  SaveCompanySetUpDetail,
} from "../../../api/User/Hub/companysetupApi";
import Fontstyling from "../../../components/common/comman";
import Required from "../../../components/Required";
import {
  clearClientData,
  selectedClientData,
} from "../../../Redux/Reducer/ClientDataReducer";
import toastFile from "../../../Service/ToastFile";
import * as Yup from "yup";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import theme from "../../../Utils/theme";
import { GetClientsDataByClientID } from "../../../api/User/ACG/clientDeatilApi";
import { AsyncPaginate } from "react-select-async-paginate";

const schema = Yup.object().shape({
  //.required("required"),
  Group_Size: Yup.string().notOneOf(
    ["SELECT GROUP SIZE", "0", null, "", 0, undefined],
    "Please select group size"
  ),
  //.required("required"),
  Industry: Yup.string().notOneOf(
    ["Select Industry", "0", null, "", 0, undefined],
    "Please select industry"
  ),
  //.required("required"),
  zip: Yup.string().required("Please enter zip code"),
});

const CompanySetUp = ({ navigate }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [dropdownData, setDropdownData] = useState({
    GroupSizeData: [],
    IndustryData: [],
    ClientDropdown: [],
  });
  const [clientData, setClientData] = useState([]);
  const [clientone, setClientone] = useState(null);
  const [regionData, setRegionData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedClientvalue, setSelectedClientValue] = useState(null);
  const [isclientValidate, setIsclientValidate] = useState(false);

  const customStyles = {
    control: (base) => ({
      ...Fontstyling.primaryparagraph,
      display: "flex",
      alignItems: "center",
      border: "1px solid #ced4da",
      borderRadius: "0px",
      width: "100%",
      minHeight: "28px",
      maxHeight: "28px",
      textAlign: "left",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        ...Fontstyling.primaryparagraph,
        textAlign: "left",
        backgroundColor:
          data.value === 0 ? "#fff" : isFocused ? "#3498ff" : null,
        color: data.value === 0 ? "#808080" : isFocused ? "white" : "#212529",
        fontSize: 12,
        paddingTop: 0,
        paddingBottom: 0,
      };
    },
  };
  useEffect(() => {
    if (client !== null && client?.client !== 0) {
      setSelectedClientValue({
        value: client?.clientID,
        label: client?.clientName,
      });
      GetClientsDataByClientID(user?.UD_id, client?.clientID).then((res) => {
        setClientone(res.data.length ? res.data[0] : null);
      });
    } else
      setSelectedClientValue({
        value: 0,
        label: "SELECT CLIENT NAME",
      });
    Promise.all([getRegionDetail(), GetIndustry(), getCompanySize()])
      .then(([regionRes, industryData, groupSizeData]) => {
        setRegionData(regionRes.data);
        setDropdownData({
          IndustryData: industryData.data.sort((a, b) =>
            a.IndustryName.localeCompare(b.IndustryName)
          ),
          GroupSizeData: groupSizeData.data,
        });
      })
      .catch((err) => console.log({ err }))
      .finally(() => setIsLoading(false));
  }, []);

  const handleActions = async (values, error) => {
    if (selectedClientvalue.value === 0) {
      return setIsclientValidate(true);
    }
    const { Client_ID, sicCode, zip, Group_Size, Industry } = values;
    const payload = {
      clientID: selectedClientvalue.value,
      userID: user?.UD_id,
      regionID: client?.regionId,
      zipCode: zip,
      sicCode: client?.siC_Sub_Industry,
      industryID: +Industry,
      companySizeID: +Group_Size,
      producer: "",
      eligible_EEs_CT: 0,
      renewal_Date: new Date().toISOString(),
      funding_Arrangement: 0,
      commission_Rate: 0,
      commission_Override: "",
      client_Contact_Name: "",
      phone: "",
      enrolled_Mbrs_Ct: 0,
      enrolled_Kaiser_Mbrs_CT: 0,
      enrolled_EEs_CT: 0,
      kaiser_EEs_CT: 0,
      industry: "",
      email_Phone: "",
      email: "",
      waived_EEs_CT: 0,
      isL_Pooling_Point: 0,
      group_Size: "",
      bill_Office: 0,
      irmI_LC_Benchmark: 0,
      main_Carriers: "",
      add_Inflation_to_ACG: "",
      medical_Inflation_Rate: 0,
      ex_Inflation_Rate: 0,
      user_Created: 0,
      zip: "",
      hiT_Tax_Included: "",
      hiT_Tax_Rate: 0,
      createdBy: 0,
      isCensusProgress: 0,
    };

    await SaveCompanySetUpDetail(payload).then((res) => {
      if (res.status === 200 || res.status === 204) {
        if (res.data === "Requested region is rejected") {
          toastFile("Region Rejected");
        } else {
          toastFile("Company Setup Saved Successfully", "success");
          navigate("/HUBExperience/medicalplansetup");
          // setTimeout(() => {
          // }, 6000);
        }
      }
    });
    // await getClientsData(user?.UD_id).then((res) => {
    //   if (res.status === 200 || res.status === 204) {
    //     let findedClient = res.data?.find(
    //       (item) => item.clientID === client?.clientID
    //     );
    //     let region = regionData?.find(
    //       (item) => item.regionID === findedClient?.regionId
    //     );
    //     dispatch(selectedClientData({ ...findedClient, ...region }));
    //   }
    // });
  };

  let findedRegion = regionData.find(
    (item) => item.regionID === client?.regionId
  );

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await getClientsDatabyPaginationbySearch(
          user.UD_id,
          page,
          searchQuery
        );
        const data = await response.data.clientsDataModelUDid;
        setClientData([...clientData, ...data]);
        const newOptions = data.map((port) => ({
          value: port.clientID,
          label: port.clientName,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };

  const handleClientChange = async (option, setValues) => {
    setIsclientValidate(false);
    setSelectedClientValue(option);
    if (option.value === "SELECT CLIENT NAME") {
      setValues({
        Client_Name: "SELECT CLIENT NAME",
        Client_ID: "0",
        hubLocalRegion: "",
        hubRegion: "",
        hubSuperRegion: "",
        sicCode: "0",
        zip: "",
        Group_Size: "SELECT GROUP SIZE",
        Industry: "Select Industry",
      });
      return;
    }
    let selectedClient = clientData.find((item) => {
      return item.clientID === Number(option.value);
    });
    dispatch(selectedClientData(selectedClient));
    let region = regionData?.find(
      (item) => item.regionID === selectedClient?.regionId
    );
    try {
      const res = await GetClientsDataByClientID(
        user?.UD_id,
        selectedClient?.clientID
      );
      setClientone(res.data.length ? res.data[0] : null);
      let findedClient = res.data[0];

      if (findedClient !== undefined) {
        setValues({
          Client_ID: option.value,
          hubLocalRegion: region ? region.hubLocal : "",
          hubRegion: region ? region.hubRegion : "",
          hubSuperRegion: region ? region.hubSuperRegion : "",
          sicCode: selectedClient ? selectedClient?.siC_Sub_Industry : "0",
          zip:
            selectedClient && selectedClient?.clientZipCode
              ? selectedClient?.clientZipCode
              : findedClient?.CompanyZipCode
              ? findedClient?.CompanyZipCode
              : "",
          Group_Size:
            findedClient?.CompanySizeID === null
              ? selectedClient?.companySizeID
              : findedClient?.CompanySizeID,
          Industry:
            findedClient?.IndustryID === null
              ? selectedClient?.industryID
              : findedClient?.IndustryID,
        });
      } else {
        setValues({
          Client_ID: option.value,
          hubLocalRegion: region ? region.hubLocal : "",
          hubRegion: region ? region.hubRegion : "",
          hubSuperRegion: region ? region.hubSuperRegion : "",
          sicCode: selectedClient?.siC_Sub_Industry
            ? selectedClient?.siC_Sub_Industry
            : "0",
          zip: selectedClient && selectedClient?.clientZipCode ? selectedClient?.clientZipCode : "",
          Group_Size:
            selectedClient?.companySizeID !== null
              ? selectedClient?.companySizeID
              : "SELECT GROUP SIZE",
          Industry:
            selectedClient?.industryID !== null
              ? selectedClient?.industryID
              : "Select Industry",
        });
      }
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  return (
    <>
      <h5
        className="mb-3 mt-1"
        style={{ fontStyle: "italic", ...Fontstyling.heading }}
      >
        {user?.UD_emp_name}
      </h5>
      <div className="mb-4">
        <p className="lh-2" style={Fontstyling.primaryparagraph}>
          Welcome to the configuration and set up page for Snapshot 360. To
          establish your client’s carrier connections, data feeds, and financial
          experience data, you will need to provide specific information at it
          pertains to your client’s benefits program. Information provided must
          be accurate and updated whenever there is a change to any of the
          required data elements below. Inaccurate, incorrect, and/or missing
          required data fields may result in an import error, which will create
          issues in the Fusion for Snapshot 360.
        </p>
        <p style={Fontstyling.primaryparagraph}>
          If this is your first time preparing an experience report, please
          watch the training video located here
          {/* <span
            className="fw-bold"
            style={{ color: theme.SECONDARY_SHOCKING_BLUE }}
          >
            HERE
          </span> */}
          . For all other assistance, select Other under service request
          {/* <span
            className="fw-bold"
            style={{ color: theme.SECONDARY_SHOCKING_BLUE }}
          >
            Service Request
          </span> */}{" "}
          and a member of the clinical informatics or financial consulting team
          will reach out to you.
        </p>
      </div>
      <div className="fw-bold" style={Fontstyling.heading}>
        Company Setup:
      </div>
      {!isLoading ? (
        <Formik
          enableReinitialize
          validationSchema={schema}
          onSubmit={handleActions}
          initialValues={{
            Client_Name: client ? client?.clientID : "SELECT CLIENT NAME",
            Client_ID: client ? client?.clientID : "0",
            hubLocalRegion: findedRegion ? findedRegion.hubLocal : "",
            hubRegion: findedRegion ? findedRegion.hubRegion : "",
            hubSuperRegion: findedRegion ? findedRegion.hubSuperRegion : "",
            sicCode: client ? client?.siC_Sub_Industry : "0",
            zip:
              client && client?.clientZipCode
                ? client?.clientZipCode
                : clientone?.ClientZipCode
                ? clientone?.ClientZipCode
                : clientone?.CompanyZipCode
                ? clientone?.CompanyZipCode
                : "",
            Group_Size:
              clientone && clientone?.CompanySizeID !== null
                ? clientone?.CompanySizeID
                : client?.companySizeID,
            Industry:
              clientone && clientone?.IndustryID !== null
                ? clientone?.IndustryID
                : client?.industryID,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
            setValues,
            setFieldError,
            resetForm,
          }) => {
            return (
              <Form id="form" onSubmit={handleSubmit}>
                <Row className="mb-2 gap-3">
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Company Name (Must be in BenefitPoint)
                        <Required />
                      </Form.Label>
                      <AsyncPaginate
                        value={selectedClientvalue || null}
                        loadOptions={loadOptions}
                        debounceTimeout={2500}
                        styles={customStyles}
                        placeholder="SELECT CLIENT NAME"
                        onChange={(option) =>
                          handleClientChange(option, setValues)
                        }
                        additional={{
                          page: 1,
                        }}
                        // isSearchable={true}
                        isOptionDisabled={(e) => e.value === 0}
                      />
                      {isclientValidate && (
                        <Form.Label
                          style={{
                            fontSize: ".875em",
                            fontWeight: 500,
                            letterSpacing: "-0.5px",
                            fontFamily: "Arial",
                            color: "#dc3545",
                            marginTop: "0.25rem",
                            fontFamily:
                              "system-ui,-apple-system,Segoe UI,Roboto,Helvetica Neue,Noto Sans,Liberation Sans,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color emoji",
                          }}
                        >
                          Please select client name
                        </Form.Label>
                      )}
                      <Form.Control.Feedback type="invalid">
                        {errors.Client_Name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {[
                    { name: "Client_ID", label: "IA ID" },
                    { name: "hubLocalRegion", label: "HUB Local Region" },
                    { name: "hubRegion", label: "HUB Region:" },
                    { name: "hubSuperRegion", label: "HUB Super Region" },
                  ].map((item, index) => (
                    <Col>
                      <Form.Group className="text-start">
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          {item.label}
                        </Form.Label>
                        <Form.Control
                          name={item.name}
                          className="py-1 rounded-0"
                          style={Fontstyling.label}
                          value={values[item.name]}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder={item.label}
                          disabled
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[item.name]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  ))}
                </Row>
                <Row className="mb-2 gap-3"></Row>
                <Row className="mb-2 gap-3">
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Main Office Zip Code
                        <Required />
                      </Form.Label>
                      <Form.Control
                        name="zip"
                        maxLength={10}
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        value={values.zip}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.zip && errors.zip}
                        type="text"
                        placeholder="Main Office Zip Code*"
                        disabled={client?.clientZipCode ? true : false}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.zip}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Sic Code
                      </Form.Label>
                      <Form.Control
                        name="sicCode"
                        type="text"
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        value={values.sicCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled
                        defaultValue="0"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Industry
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.dropdown_label}
                        name="Industry"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.Industry}
                        isInvalid={touched.Industry && errors.Industry}
                      >
                        <option value={0}>--Select Industry--</option>
                        {dropdownData.IndustryData.map((item, index) => (
                          <option
                            key={index}
                            value={item.IndustryID}
                            // selected={values.Industry === item}
                          >
                            {item.IndustryName}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.Industry}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Group Size
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.dropdown_label}
                        name="Group_Size"
                        onChange={handleChange}
                        value={values.Group_Size}
                        onBlur={handleBlur}
                        isInvalid={touched.Group_Size && errors.Group_Size}
                      >
                        <option value={0}>--SELECT GROUP SIZE--</option>
                        {dropdownData.GroupSizeData.map((item) => (
                          <option
                            value={item.CompanySizeID}
                            key={item.CompanySizeID}
                            // selected={item.CompanySizeName === values.Group_Size}
                          >
                            {item.CompanySizeName}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.Group_Size}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-md-flex d-block align-items-center gap-3 mt-4">
                  <button
                    style={Fontstyling.savebutton}
                    type="submit"
                    onClick={() =>
                      selectedClientvalue.value === 0 &&
                      setIsclientValidate(true)
                    }
                  >
                    Save & Continue
                  </button>
                  <button
                    type="button"
                    style={Fontstyling.cancelbutton}
                    onClick={() => resetForm()}
                  >
                    Cancel
                  </button>
                  <div
                    className="mt-md-0 mt-3"
                    style={Fontstyling.secondaryparagraph}
                  >
                    To edit pre-populated company information, please make
                    changes in BenefitPoint and return to Infused Analytics
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      ) : (
        <Spinner className="m-auto" />
      )}
    </>
  );
};

export default CompanySetUp;
